import axios from 'axios';

/**
 * Determine the API base URL.
 *
 * Strategy (in order of priority):
 *   1. If we're running on a production-style custom domain (gbacommunity.gauravbhagatacademy.com),
 *      ALWAYS use that domain — regardless of what build-time env var was baked in. This recovers
 *      from a stale REACT_APP_BACKEND_URL pointing to a no-longer-existing internal hostname.
 *   2. Otherwise, prefer the build-time REACT_APP_BACKEND_URL.
 *   3. Otherwise, fall back to window.location.origin (same-domain routing via Kubernetes ingress).
 */
const PROD_HOST = 'gbacommunity.gauravbhagatacademy.com';
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const RUNTIME_ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
const RUNTIME_HOST = typeof window !== 'undefined' ? window.location.hostname : '';

let BASE;
if (RUNTIME_HOST === PROD_HOST) {
  BASE = `https://${PROD_HOST}`;
} else if (ENV_URL && ENV_URL.length > 0) {
  BASE = ENV_URL;
} else {
  BASE = RUNTIME_ORIGIN;
}
const API_URL = `${BASE.replace(/\/+$/, '')}/api`;

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
